import React from 'react';
import { Colonnina, Connettore, STATO_CONNETTORE } from './dati';

// Senza segnale dal gateway gli stati non sono affidabili: si dice
// "sconosciuto" invece di mostrare l'ultimo stato noto.
const SCONOSCIUTO = { label: 'Stato sconosciuto', badge: 'bop-badge--neutral' };

export function StatoColonnina({ colonnina, gatewayOk }: { colonnina: Colonnina; gatewayOk: boolean }) {
  if (!colonnina.attiva) {
    return <span className="bop-badge bop-badge--neutral">Disattivata</span>;
  }
  if (!colonnina.passwordImpostata) {
    return <span className="bop-badge bop-badge--warning">Password da generare</span>;
  }
  if (!gatewayOk) {
    return <span className={`bop-badge ${SCONOSCIUTO.badge}`}>{SCONOSCIUTO.label}</span>;
  }
  return colonnina.collegata
    ? <span className="bop-badge bop-badge--success">Collegata</span>
    : <span className="bop-badge bop-badge--danger">Non collegata</span>;
}

export function StatoPresa({ presa, gatewayOk }: { presa: Connettore; gatewayOk: boolean }) {
  const s = gatewayOk ? STATO_CONNETTORE[presa.stato] : SCONOSCIUTO;
  return <span className={`bop-badge ${s.badge}`}>{s.label}</span>;
}

export function Prese({ connettori, gatewayOk }: { connettori: Connettore[]; gatewayOk: boolean }) {
  if (connettori.length === 0) return <span className="bop-text-muted">—</span>;
  return (
    <span className="bop-ricarica__connettori">
      {connettori.map((p) => {
        const s = gatewayOk ? STATO_CONNETTORE[p.stato] : SCONOSCIUTO;
        return (
          <span key={p.numero} className={`bop-badge ${s.badge}`}>
            {p.numero} · {s.label}
          </span>
        );
      })}
    </span>
  );
}

export function Kpi({ label, valore }: { label: string; valore: string }) {
  return (
    <div className="bop-ricarica__kpi">
      <div className="bop-ricarica__kpi-label">{label}</div>
      <div className="bop-ricarica__kpi-valore">{valore}</div>
    </div>
  );
}

export function Campo({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <div className="bop-ricarica__campo-label">{label}</div>
      <div className="bop-ricarica__campo-valore">{children}</div>
    </div>
  );
}
